import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { AlertService } from 'src/app/components/alert/alert.service';
import { PolicyService } from 'src/app/modules/policy/policy.service';
import { IFormKey, IFormSelectOption } from 'src/app/modules/shared/models/forms';
import { ICityObject } from 'src/app/modules/shared/models/policy.model';
import { LoggerService } from 'src/app/services/logger.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { registry_adjustment_form_keys } from './registry-adjustment.constants';

@Component({
  selector: 'app-registry-adjustment',
  templateUrl: './registry-adjustment.component.html',
  styleUrl: './registry-adjustment.component.scss'
})
export class RegistryAdjustmentComponent implements OnInit, OnDestroy {

  constructor(
    private readonly _spinnerService: SpinnerService,
    private readonly _policyService: PolicyService,
    private readonly _alertService: AlertService
  ) { }

  @Input() form: FormGroup;
  @Input() countriesList: IFormSelectOption[];
  @Input() provincesList: IFormSelectOption[];

  formKeys: IFormKey[] = registry_adjustment_form_keys;

  destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.manageFormKeys();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  manageFormKeys(): void {
    if (this.formKeys) {
      const countryKey = this.formKeys.find(key => key.controlName === 'statoNascita');
      if (countryKey) {
        countryKey.options = this.countriesList;
      }
      const provinceKey = this.formKeys.find(key => key.controlName === 'provinciaNascita');
      if (provinceKey) {
        provinceKey.options = this.provincesList;
        this.retrievePlaces(this.form.get('provinciaNascita')?.value);
      }
    }
  }

  retrievePlaces(provinceCode: string): void {
    this._spinnerService.show();
    this._policyService.retrieveCities(provinceCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: { listaComuni: ICityObject[] }) => {
          if (response) {
            const placesList = response.listaComuni?.map((cityObj: ICityObject) => ({
              key: cityObj.cityName,
              value: cityObj.cityName
            }));
            const key = this.formKeys.find(k => k.controlName === 'comuneNascita');
            if (key) {
              key.options = placesList;
            }
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'retirevePlaces', error);
          this._alertService.openErrorMessage('Errore nel recupero della lista delle città', 'retirevePlaces', error);
          this._spinnerService.hide();
        }
      })
    }

}
